export default [
  'com',
  'cn',
  'net',
  'biz',
  'info',
  'mobi',
  'com.cn',
  'org.cn',
  'net.cn',
  'club',
  'xyz',
  'company',
  'world',
  'store',
  'fund',
  'gold',
  'group',
  'ltd',
  'tech',
  'top',
  'site',
  'link',
  'online',
  'ink',
  'vip',
  'shop',
  'work',
  '购物',
  'art',
  'wang',
  'wiki',
  'design',
  'co',
  // '移动',
  // '在线',




  //  '中国' ,
  //  '公司' ,
  //  '网络' ,
  //  '中文网' ,
  //  '企业' ,
  //  '网址',
  //  '手机' ,
  //  '网店' ,
  //  '集团' ,
]


// WEBPACK FOOTER //
// ./static/assets/domain-infoen.js